/** The table's data columns after the checkbox, in order. */
export const BARCODE_ISSUES_COLUMNS = [
    'product',
    'variant',
    'sku',
    'barcode',
    'role',
    'problem',
    'fix',
    'stock',
] as const;

/** The placeholder rows' ids while the first page loads. */
export const BARCODE_ISSUES_SKELETON_KEYS = ['s0', 's1', 's2', 's3', 's4'];
